import * as React from 'react';

import Image from 'lib/image-container';
import { SupportedLanguage } from 'lib/lexemes/supported-languages';
import LocaleContext from 'lib/locale-context';
import { useDetectPrint } from 'lib/use-detect-print';
import { MediaQueryWidth } from 'lib/use-media-query';
import useScrollbarWidth from 'lib/use-scrollbar-width';

import { Columns } from 'components/columns';
import ColumnsItem, { ColumnsSize } from 'components/columns/columns-item';
import { CtaBox, CtaBoxText } from 'components/cta-box';
import PageSection from 'components/page/page-section';
import {
  COLUMNS_GAP_MEDIUM,
  IMAGE_MAX_WIDTH_1,
  PAGE_PADDING_LARGE,
  PAGE_PADDING_MEDIUM,
  PAGE_PADDING_SMALL,
} from 'components/page/sections';

import { getPropsSectionEightContainer } from './section-eight-container.props';

export const SectionEightContainer: React.FC = () => {
  const lang = React.useContext(LocaleContext);
  const props = getPropsSectionEightContainer({ lang } as {
    lang: SupportedLanguage;
  });
  const scrollbarWidth = useScrollbarWidth(true);
  const isPrinting = useDetectPrint();
  return (
    <div className="navigation-block" id={props.sections.one.id}>
      <PageSection color="peach" extraClass="section-cta" padding="block" inner={true}>
        <Columns hasMobileLayout={true}>
          <ColumnsItem size={isPrinting ? ColumnsSize['1/1'] : ColumnsSize['1/2']}>
            <CtaBox align="start">
              <CtaBoxText>{props.sections.one.text}</CtaBoxText>
            </CtaBox>
          </ColumnsItem>
          {isPrinting ? null : (
            <ColumnsItem verticalAlign="stretch" size={ColumnsSize['1/2']}>
              <Image
                width={570}
                height={330}
                style={{
                  objectFit: 'cover',
                  objectPosition: props.sections.one.imageObjectPosition,
                }}
                quality={75}
                src={props.sections.one.imageSrc}
                alt=""
                sizes={`
                (max-width: ${MediaQueryWidth['desktop-sm']}px) calc(100vw - 2 * ${PAGE_PADDING_SMALL} - ${scrollbarWidth}),
                (max-width: ${MediaQueryWidth['tablet-lg']}px) calc((100vw - 2 * ${PAGE_PADDING_MEDIUM} - ${COLUMNS_GAP_MEDIUM} - ${scrollbarWidth}) / 2),
                (max-width: ${MediaQueryWidth['content-max']}px) calc((100vw - 2 * ${PAGE_PADDING_LARGE} - ${COLUMNS_GAP_MEDIUM} - ${scrollbarWidth}) / 2),
                ${IMAGE_MAX_WIDTH_1}
            `}
              />
            </ColumnsItem>
          )}
        </Columns>
      </PageSection>
    </div>
  );
};
